export const config = {
  auth: {
    host: JSON.parse('"https://sso.trustap.com"'),
    realm: JSON.parse('"trustap"'),
    clientId: JSON.parse('"trustap_new_console"'),
    redirectUri: JSON.parse('"https://dashboard.trustap.com/"'),
    responseType: "code",
    scope: "openid profile email",
    automaticSilentRenew: true,
    accessTokenExpiringNotificationTimeInSeconds: 30,
    realmRequiredRoles: ["admin", "reader"],
    clientRequiredRoles: ["admin", "reader"],
    ignoredClients: ["account"],
  },
  api: {
    // `base_url` is the URL for the backend API of this project, of the form
    // <https://{host}/api>.
    baseUrl: JSON.parse('"https://dashboard.trustap.com/api"'),
  },
  stripe: {
    dashboardUrl: JSON.parse('"https://dashboard.stripe.com"'),
    isTest: JSON.parse('false'),
  },
  localization: {
    timeZone: "UTC",
    locale: "en-GB",
  },
  clientMetadata: {
    defaultDebtThreshold: 200000,
  },
  analytics: {
    clarityProjectId: JSON.parse('"gfntbkyymm"'),
  },
  supportEmail: "support@trustap.com",
  solutionsEmail: "solutions@trustap.com",
  feedbackFormUrl:
    "https://trustap.atlassian.net/jira/software/form/2564d20c-3635-47c2-aca1-1c52c32327c1?atlOrigin=eyJpIjoiMGQzNDEwNjk3OWY2NDU4Zjg1NjIyNzQ2MmU2MmU5NDAiLCJwIjoiaiJ9",
  contactSupportUrl: "https://trustap.zendesk.com/hc/en-us/requests/new",
  muiXLicenseKey: JSON.parse('"813a66aee9a858431e2efc9577bc8f15Tz0xMjU4NjAsRT0xODAzMDgxNTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI="'),
  clientIdPrefix: JSON.parse('"cid"'),
};
